import axios from "axios";
import type {
  BadgeAward,
  ManualAwardRequest,
} from "@/modules/learningCenter/features/BadgeManagement/types/badgeAward.types";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";

/**
 * Manually award a badge to a user
 *
 * @param payload - Manual award request data
 * @returns The created badge award
 */
export const manuallyAwardBadge = async (
  payload: ManualAwardRequest,
): Promise<BadgeAward> => {
  const response = await axios.post<BadgeAward>(
    `${API_BASE_URL}/badges/awards/manual`,
    payload,
  );
  return response.data;
};

export default manuallyAwardBadge;
